import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { ReactComponent as SvgDecoratorBlob3 } from "images/svg-decorator-blob-3.svg";

const SectionContainer = styled(Container)`
  background: linear-gradient(180deg, #FDFAF6 0%, #F0FAF9 100%);
`;

const Heading = styled(SectionHeading)`
  font-family: 'Cormorant Garant', serif;
  color: #0C2A29;
  font-size: 2.75rem;
`;

const Subheading = styled(SubheadingBase)`
  ${tw`text-center mb-3`}
  color: #2A9D8F;
  font-family: 'Nunito', sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-size: 0.8rem;
`;

const Description = tw(SectionDescription)`text-center mx-auto`;

const ThreeColumnContainer = styled.div`
  ${tw`mt-12 flex flex-col items-center lg:items-stretch lg:flex-row flex-wrap lg:justify-center max-w-screen-lg mx-auto`}
  gap: 1.5rem;
`;

const Column = styled.div`
  ${tw`lg:w-1/3 max-w-xs`}
  flex: 1 1 260px;
  max-width: 320px;
`;

const Card = styled.div`
  ${tw`flex flex-col items-center text-center h-full px-6 py-10 rounded-2xl transition-all duration-300`}
  background: #fff;
  border: 1px solid rgba(42, 157, 143, 0.1);
  cursor: default;

  &:hover {
    box-shadow: 0 16px 48px rgba(42, 157, 143, 0.12);
    transform: translateY(-4px);
    border-color: rgba(42, 157, 143, 0.25);
  }

  .imageContainer {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: linear-gradient(135deg, #E0F5F3, #B3E8E2);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
    flex-shrink: 0;

    img {
      width: 40px;
      height: 40px;
      object-fit: contain;
    }
  }

  .title {
    font-family: 'Cormorant Garant', serif;
    font-size: 1.4rem;
    font-weight: 700;
    color: #0C2A29;
    margin-top: 0.5rem;
    line-height: 1.2;
  }

  .description {
    margin-top: 0.75rem;
    font-size: 0.9rem;
    line-height: 1.65;
    color: #264F5D;
    font-family: 'Nunito', sans-serif;
    font-weight: 400;
  }

  .accent-bar {
    width: 40px;
    height: 3px;
    background: linear-gradient(90deg, #2A9D8F, #42C1B7);
    border-radius: 2px;
    margin: 1rem auto 0;
  }
`;

const DecoratorBlob = styled(SvgDecoratorBlob3)`
  ${tw`pointer-events-none absolute right-0 bottom-0 w-64 opacity-10 transform translate-x-32 translate-y-40`}
`;

export default ({
  cards = [],
  heading = "",
  subheading = "",
  description = "",
  imageContainerCss = null,
  imageCss = null,
  id = ""
}) => {
  return (
    <SectionContainer>
      <a id={id} style={{ display: 'block' }}>
        <ContentWithPaddingXl>
          {subheading && <Subheading>{subheading}</Subheading>}
          {heading && <Heading>{heading}</Heading>}
          {description && <Description>{description}</Description>}
          <ThreeColumnContainer>
            {cards.map((card, i) => (
              <Column key={i}>
                <Card>
                  <span className="imageContainer" css={imageContainerCss}>
                    <img src={card.imageSrc} alt={card.title} css={imageCss} />
                  </span>
                  <span className="title">{card.title}</span>
                  <p className="description">{card.description}</p>
                  <div className="accent-bar" />
                </Card>
              </Column>
            ))}
          </ThreeColumnContainer>
        </ContentWithPaddingXl>
      </a>
      <DecoratorBlob />
    </SectionContainer>
  );
};
